<footer class="footer">
  <div class="footer__container">
    <div class="footer__row">
      <div class="footer__column">
        <div class="footer__bio">
          <p class="footer__heading">Banjo Hootson</p>
          <p>Born in Yorkshire.</p>
          <p>Raised on pints and social media.</p>
          <p>
            Made in
            <span class="footer__line-through">the Royal Navy</span>
            Ikea.
          </p>
        </div>
      </div>

      <div class="footer__column">
        <div class="footer__location">
          <p class="footer__heading">Location</p>
          <p>Selby</p>
          <p>United Kingdom</p>
        </div>
      </div>

      <div class="footer__column">
        <div class="footer__contact">
          <p class="footer__heading">Contact</p>
          <ul class="footer__list">
            <li>
              <a href="mailto:hello@banjohootson.com">hello&#64;banjohootson.com</a>
            </li>
            <li>
              <a href="https://www.instagram.com/banjohootson/" target="_blank" rel="noopener noreferrer">Instagram</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</footer>
